import { render, staticRenderFns } from "./my-profile.vue?vue&type=template&id=0ad817c6&scoped=true"
import script from "./my-profile.vue?vue&type=script&lang=js"
export * from "./my-profile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad817c6",
  null
  
)

export default component.exports